export default __webpack_public_path__ + "static/media/Platform-Xrathus-Preview.b7690c3b.svg";